@if (isApp()) {
  <div class="app-header-container"></div>
}
<header
  class="custom-header"
  [class.deactivated]="deactivated()">
  <div
    class="header-left-part"
    role="banner">
    <div class="mod-logo">
      <ng-container *coinFeatureFlag="'displayEnvironment'">
        @if ((responsive.isMobile$ | async) === false) {
          <div class="environment">
            <mat-icon>{{ currentEnvironment.icon }}</mat-icon>
            <div class="environment-name">
              <p class="bold">{{ currentEnvironment.type }}</p>
              @if (currentEnvironment['featurePrefix']) {
                <p class="bold">{{ currentEnvironment['featurePrefix'] }}</p>
              }
            </div>
          </div>
        }
      </ng-container>
    </div>
  </div>
  <coin-user-menu></coin-user-menu>
  <div
    class="header-right-part"
    [class.big-margin]="isAuthenticated$ | async">
    @if (updateNotifications.hasUpdates()) {
      <coin-update-notifier></coin-update-notifier>
    }
    <coin-chat-bot></coin-chat-bot>
    <coin-v2-button
      text="{{ (responsive.isMobile$ | async) ? '' : ('faq.whats-new' | translate) }} ?"
      type="secondary"
      [matBadge]="totalNewFlags()"
      [matBadgeHidden]="totalNewFlags() === 0"
      [matBadgeOverlap]="true"
      (click)="toggleFaq()"></coin-v2-button>
    @if (!(isAuthenticated$ | async)) {
      <coin-v2-button
        type="primary"
        icon="chevron_right"
        iconPos="right"
        aria-label="Login"
        [text]="'general.login' | translate"
        (click)="login()"></coin-v2-button>
    }
  </div>
  @if (showFaq()) {
    <div
      animate.enter="slide-in"
      animate.leave="slide-out"
      class="faq-sidebar"
      [ngClass]="{ 'no-menu-spacing': !(isAuthenticated$ | async) }">
      <coin-siemens-energy-faq-menu
        [helpData]="helpData()[languageSelected()]"
        [isLoading]="isHelpDataLoading()"
        (close)="toggleFaq()"
        (openOtherTopic)="onOpenOtherFaqTopic($event)"></coin-siemens-energy-faq-menu>
    </div>
  }
</header>
